export default "__VITE_ASSET__BPeu2c7K__"